import { Cookies } from "react-cookie";
import cookiesKeys from "Common/cookies/cookiesKeys";
const setCookieHunter = (token) => {
    const cookies = new Cookies();
    cookies.set(cookiesKeys.hunter, token, {
        path: "/",
        sameSite: "lax"
    });
};
export default setCookieHunter;
